import React, { Component } from 'react'
import moment from 'moment';
import Input from './shared/Input';
import Button from './shared/Button';
import { connect } from "react-redux";
import Loader from './shared/Loader'
import profileApi from '../api/auth'
import { profileUpdateStages, profileClearStagesResult, profileFetch } from '../store/profile/actions'
import { SHORT_SUBJECT_TYPE } from './../constants/subjectTypes';
import { get, isEmpty } from 'lodash'
import ReactPhoneInput from './shared/PhoneInput';
import Timer from './LanguageTest/Timer';

import baseStyles from 'custom/base.styl';
import classnames from "classnames";
import validate from "../utils/validate";

import { trackValues } from './../tracker';
import { trackSiteId } from './../config';
class PhoneVerification extends Component {
  constructor(props) {
    super(props)

    this.onPhoneChange = this.onPhoneChange.bind(this)
    this._handleOnChange = this._handleOnChange.bind(this)
    this._handleSubmit = this._handleSubmit.bind(this)
    this._requestCode = this._requestCode.bind(this)
    this._verifyCode = this._verifyCode.bind(this)
    this._handleOnClickSendNewCode = this._handleOnClickSendNewCode.bind(this)
    this.submitName = this.submitName.bind(this)
    this.onChangeNumber = this.onChangeNumber.bind(this)
    this.timeout = this.timeout.bind(this)

    this.state = {
      name: '',
      surname: '',
      phone: '',
      code: '',
      codeReceived: false,
      fieldError: {},
      errors: [],
      codeSending: false,
      isChangePhone: false,
      endTime: localStorage.getItem('endTimeSms') || null,
    }
  }

  componentDidMount() {
    const { profilePhone, name, surname } = this.props

    this.setState({
      phone: profilePhone,
      name,
      surname,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profilePhone !== this.props.profilePhone) {
      this.setState({
        phone: this.props.profilePhone
      });
    }
    if (prevProps.name !== this.props.name) {
      this.setState({
        name: this.props.name,
      });
    }
    if (prevProps.surname !== this.props.surname) {
      this.setState({
        surname: this.props.surname,
      });
    }
  }

  hasPhone() {
    const { phone } = this.state;
    return ((phone || '').trim() || '').length > 6;
  }

  timeout() {
    localStorage.removeItem('endTimeSms');
    this.setState({ endTime: null });
  }

  onPhoneChange(phone) {
    this.setState({ phone });
  }

  _handleOnChange(e) {
    const { name: nameInput, value } = e.target

    this.setState({
      [nameInput]: nameInput === 'name' || nameInput === 'surname' ? value : value.trim()
    });
  }

  _handleSubmit(e) {
    e.preventDefault();
  }

  _verifyCode() {
    const { code, phone, name, surname } = this.state;

    const data = {
      code,
      first_name: name,
      last_name: surname,
      phone
    };

    this.props.profileUpdateStages(data)
  }

  _requestCode() {
    const { phone, name, surname } = this.state;

    const data = {
      phone: (phone || '').replace(/[^+0-9]/g, ''),
      first_name: name,
      last_name: surname,
    }

    const isValid = this._handleValidate();

    if (!isValid) {
      return false;
    }

    const endTime = moment().add(2, 'minutes').format();
    localStorage.setItem('endTimeSms', endTime);

    this.setState({
      codeSending: true,
      isChangePhone: false,
      endTime,
    })

    profileApi.requestCode(data).then(resp => {
      this.setState({
        codeReceived: true,
        errors: [],
        codeSending: false,
      })
    }).catch(error => {
      this.setState({
        codeSending: false,
      });

      this.setState({
        errors: get(error, 'errors', [])
      })
    });
  }

  submitName() {
    const { phone, name, surname } = this.state;
    const data = {
      first_name: name.trim(),
      last_name: surname.trim(),
      phone,
    };

    const { version, userId, subjectType } = this.props;
    const dataTracker = { userId, version, site_id: trackSiteId, preferredSubject: SHORT_SUBJECT_TYPE[subjectType], is_optional: true }

    trackValues('phone_verification', true, {
      context: dataTracker,
    });

    this.props.profileUpdateStages(data)
  }

  onChangeNumber(e) {
    e.preventDefault()

    this.setState({
      isChangePhone: true,
      code: '',
    });
  }

  _handleOnClickSendNewCode(e) {
    e.preventDefault()
    this.props.profileClearStagesResult()
    this._requestCode()
  }

  _handleValidate() {
    const { name, surname } = this.state;

    const validateFields = [
      { name: 'name', value: name, validators: ['isRequired'] },
      { name: 'surname', value: surname, validators: ['isRequired'] },
    ];

    const fieldError = validate(validateFields);

    this.setState({
      fieldError: fieldError,
    });

    return isEmpty(fieldError);
  }


  render() {
    const { isFetching, stagesResult, countryCode, errorsProfile } = this.props;
    const { phone, name, surname, codeReceived, code, fieldError, errors, codeSending, isChangePhone, endTime } = this.state;

    if (isFetching) {
      return <Loader absolute />
    }

    const hasName = !!((name).trim()) && !!((surname).trim());
    const disabled = !this.hasPhone();

    return (
      <div>
        <div div className={baseStyles.content} key='phone-verfication-intro' >
          <h2 className={classnames(baseStyles.succeess_title, baseStyles.text_large, baseStyles.mb_10, baseStyles.centered)}>Congratulations!</h2>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.centered, baseStyles.mb_20, baseStyles.text_light)}>
            One out of three stages is completed! <br/>
            You’ve nailed the language test and now we’d like to know a bit more about you.
            </p>
        </div>

        <div className={baseStyles.form_styles} key='phone-verfication-form'>
          {/* {(subjectType === 'math' || subjectType === 'finance') &&
            <div div className={baseStyles.content} key='phone-verfication-intro' >
              <p className={classnames(baseStyles.title_extra_small, baseStyles.centered, baseStyles.mb_20, baseStyles.text_light)}>
                One out of three stages is completed! You’ve nailed the language test and now we’d like to know a bit more about you.
              </p>
            </div>
          } */}
          <form onSubmit={this._handleSubmit} method="post">
            <div className={baseStyles.form_field}>
              <h4 className={baseStyles.form_label}>First name</h4>
              <Input type="text" placeholder="Enter your first name"
                value={name}
                name="name"
                block
                className={fieldError.name ? 'error' : ''}
                onChange={this._handleOnChange} />

              {fieldError.name && <h4 className={baseStyles.form_label_error}>{fieldError.name}</h4>}
            </div>

            <div className={baseStyles.form_field}>
              <h4 className={baseStyles.form_label}>Surname</h4>
              <Input type="text" placeholder="Enter your surname"
                value={surname}
                name="surname"
                block
                className={fieldError.surname ? 'error' : ''}
                onChange={this._handleOnChange} />

              {fieldError.surname && <h4 className={baseStyles.form_label_error}>{fieldError.surname}</h4>}
            </div>

            {/* {!codeReceived && */}
            <div className={baseStyles.form_field}>
              <h4 className={baseStyles.form_label}>Phone number</h4>
              <div className={baseStyles.field_wrap}>
                <ReactPhoneInput
                  onChange={this.onPhoneChange}
                  value={phone}
                  defaultCountry={countryCode}
                  placeholder="Enter phone number"
                  inputClass={baseStyles.phone_field}
                  disableAreaCodes={true}
                  disabled={(codeSending || codeReceived) && !isChangePhone}
                />
                <Button
                  className={baseStyles.btn_verify}
                  success
                  disabled={(disabled || codeSending || codeReceived || endTime) && !isChangePhone}
                  // disabled={disabled || codeSending || codeReceived}
                  type="button"
                  onClick={this._requestCode}
                >
                  {codeSending &&
                    <i className={baseStyles.icon_spin}>&#xe838;</i>
                  }
                  {!codeSending &&
                    <span>Verify</span>
                  }
                </Button>

              </div>
              <p className={baseStyles.form_desc}>
                You can skip phone number verification now, but at the last stage of our recruiting process we will still ask you verify your phone number. <br />
                We use it exclusively for notifying you about our major updates, and you always have a right to unsubscribe from the notifications if you want to.
              </p>
            </div>
            {/* } */}

            {/* {codeReceived && */}
            <div className={baseStyles.form_field}>
              <h4 className={baseStyles.form_label}>Enter code from SMS</h4>
              <div className={baseStyles.field_wrap}>
                <Input type="text" placeholder="Enter code"
                  value={code}
                  name="code"
                  className={classnames({ [baseStyles.error]: !stagesResult })}
                  block onChange={this._handleOnChange} />
                <Button className={baseStyles.btn_verify} success disabled={disabled || codeSending || !codeReceived || !code} type="button" onClick={this._verifyCode}>Submit</Button>
              </div>
              {!stagesResult && <h4 className={baseStyles.form_label_error}>Incorrect code</h4>}
            </div>
            {/* } */}

            {!endTime &&
              <div className={classnames(baseStyles.space_bottom, baseStyles.form_common_desc)}>
                <span>Didn’t get the code?</span>
                <a href="" onClick={(e) => this.onChangeNumber(e)}>Change number</a>
                <span>&nbsp;or</span>
                <a href="" onClick={this._handleOnClickSendNewCode}>Resend</a>
              </div>
            }
            {endTime &&
              <div className={classnames(baseStyles.space_bottom, baseStyles.form_common_desc)}>
                Didn’t get the code? <br /> Change number or Resend in <Timer endTime={endTime} submitTest={() => this.timeout()} /> min
              </div>
            }

            {errors.map((item, key) => <div key={`registration-error-${key}`}
              className={classnames(baseStyles.text_danger, baseStyles.space_bottom)}>{item}</div>)}

            {errorsProfile.map((item, key) => <div key={`registration-error-${key}`}
              className={classnames(baseStyles.text_danger, baseStyles.space_bottom)}>{item}</div>)}

            <div className={baseStyles.form_field}>
              {/* <Button disabled={!hasName} type="button" block onClick={!codeReceived ? this.submitName : this._verifyCode}>{!codeReceived ? 'Get started' : 'Submit verification code'}</Button> */}
              <Button disabled={!hasName || !this.hasPhone()} type="button" block onClick={!codeReceived ? this.submitName : this._verifyCode}>Get started</Button>
            </div>
          </form>

        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const profile = state.profile;
  const profilePhone = get(profile.data, 'user.profile.phone');
  const first = get(profile.data, 'user.profile.first_name') || '';
  const last = get(profile.data, 'user.profile.last_name') || '';
  const countryCode = get(profile.data, 'user.profile.geoip_country_code');
  const subjectType = get(profile.data, 'user.profile.subject_type');
  const errorsProfile = get(profile, 'error.errors');
  const userId = get(state.profile.data, 'user.id');
  const version = get(state.profile.data, 'user.scenario_version');
  const profileStage = get(state.profile.data, 'user.stage');

  return {
    profilePhone,
    profileName: `${first} ${last}`.trim(),
    name: first,
    surname: last,
    countryCode: (countryCode || '').toLowerCase(),
    isFetching: profile.isFetching,
    stagesResult: profile.stagesResult,
    subjectType,
    errorsProfile: errorsProfile || [],
    version,
    userId,
    profileStage,
  };
};

const mapDispatchToprops = dispatch => ({
  profileUpdateStages: (data) => (dispatch(profileUpdateStages(data))),
  profileClearStagesResult: () => (dispatch(profileClearStagesResult())),
  loadProfile: () => dispatch(profileFetch()),
});

export default connect(mapStateToProps, mapDispatchToprops)(PhoneVerification);



// WEBPACK FOOTER //
// ./src/components/PagePhoneVerification.js